import * as React from 'react'

const IconBlock = (props) => (
  <svg
    data-name='Layer 1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 70.6 70.6'
    width={71}
    height={71}
    {...props}
  >
    <path d='M35.3 0a35.3 35.3 0 1 0 35.3 35.3A35.29 35.29 0 0 0 35.3 0Zm0 66.8a31.37 31.37 0 0 1-21.5-8.5h31.1a6.6 6.6 0 1 0 0-13.2H20.1a5.81 5.81 0 0 1-5.7 4.6 5.89 5.89 0 0 1-5.7-4.6H5.3L4.7 43h5.9a3.9 3.9 0 1 0 7.8 0h20a6.66 6.66 0 0 0 6.6-6.6 6.66 6.66 0 0 0-6.6-6.6H20.2a5.81 5.81 0 0 1-5.7 4.6 5.89 5.89 0 0 1-5.7-4.6H4.3c.1-.7.3-1.4.4-2.1h5.9a3.9 3.9 0 1 0 7.8 0h31.4a6.66 6.66 0 0 0 6.6-6.6 6.66 6.66 0 0 0-6.6-6.6H11.7a31.48 31.48 0 1 1 23.6 52.3Zm-5-15.1a3.9 3.9 0 0 1 3.9-3.9 3.84 3.84 0 0 1 3.9 3.9 3.9 3.9 0 1 1-7.8 0Zm9 0a3.9 3.9 0 1 1 3.9 3.9 4 4 0 0 1-3.9-3.9Zm-6.6-15.3a3.9 3.9 0 1 1 3.9 3.9 3.9 3.9 0 0 1-3.9-3.9Zm-6.6-15.3A3.9 3.9 0 1 1 30 25a3.84 3.84 0 0 1-3.9-3.9Zm9 0A3.9 3.9 0 1 1 39 25a3.84 3.84 0 0 1-3.9-3.9Zm9 0A3.9 3.9 0 1 1 48 25a3.84 3.84 0 0 1-3.9-3.9Z' />
  </svg>
)

export default IconBlock
